import { useEffect } from "react";

export default function useClickOutsideHook(ref, childRef, onClose) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && childRef.current && !ref.current.contains(event.target) && !childRef.current.contains(event.target)) {
        onClose();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, childRef, onClose]);
};